export default "__VITE_ASSET__BzModScw__";